export default function(api: GlobalFetch) {
  return async function(values) {
    await api.fetch(
      `/api/v2/booking/delete/id_integration/${values.id_integration}`,
      {
        method: 'POST',
      },
    )
  }
}
